import React, { useEffect } from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, IconButton, InputAdornment, List, ListItem, Tooltip, Typography } from "@material-ui/core";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditTextField from "../../EditArticle/EditTextField";
import { updateArticle, updateArticlesTranslations, uploadArticleImage } from "../../../store/articles/ArticlesApi";
import EditSelect from "../../EditArticle/EditSelect";
import { setVatOptions } from "../../../store/articles/ArticlesActions";
import EditNumberField from "../../EditArticle/EditNumberField";
import EditImage from "../../EditArticle/EditImage";
import Modifiergroups from "./Modifiergroups";
import Printgroups from "./Printgroups";
import Menugroups from "./Menugroups";
import EditPriceTextField from "../../EditArticle/EditPriceTextField";
import EditCheckbox from "../../EditArticle/EditCheckbox";
import { useDialog } from "../../Dialogs/DialogProvider";
import EditSwitch from "../../EditArticle/EditSwitch";
import PriceFieldArticle from "./PriceFieldArticle";
import { Close } from "@material-ui/icons";
import { getTagsString } from "../../../store/articles/models/MenuTag";
import { Article } from "../../../store/articles/models/Article";
import cloudStore from "../../../store/CloudStore";
import OpeningHours from "../../OpeningHours/OpeningHours";
import { getTranslationValue } from "../../../store/articles/ArticlesHelpers";
import EditColorPicker from "../../EditArticle/EditColorPicker";
import GetCurrency from "../../../helper/GetCurrency";
import Supergroups from "./Supergroups";

const useStyles = makeStyles(() => ({
  listAllergens: {
    display: "flex",
  },
  marginBottom10: {
    marginBottom: 10,
  },
  padding10: {
    padding: 10,
  },
  rootTitle: { marginRight: 40 },
}));

function ArticleDetailsDialog(props) {
  const classes = useStyles();
  const [article, setArticle] = React.useState(
    props.articleId ? articlesStore.articles[props.articleId] : new Article()
  );
  const [, closeDialog] = useDialog();

  const onChange = () => {
    setArticle(articlesStore.articles[props.articleId]);
  };

  useEffect(() => {
    articlesStore.on(articlesStore.events.ARTICLES_UPDATED, onChange);
    return () => {
      articlesStore.removeListener(articlesStore.events.ARTICLES_UPDATED, onChange);
    };
  }, []);

  const updateTranslations = (value) => {
    return updateArticlesTranslations(
      articlesStore.merchantId,
      [article],
      [{ translation: { [props.currentLanguage]: value } }]
    ).then(Promise.resolve());
  };

  const updateTranslationsDescription = (value) => {
    return updateArticlesTranslations(
      articlesStore.merchantId,
      [article],
      [{ description_translation: { [props.currentLanguage]: value } }]
    ).then(Promise.resolve());
  };

  if (article == null) {
    return <div></div>;
  }

  return (
    <>
      <DialogTitle id="form-dialog-title">
        <div style={{ display: "flex" }}>
          <Typography variant={"h5"} classes={{ h5: classes.rootTitle }}>
            {props.intl.formatMessage({ id: "edit_article" })}
          </Typography>
          <EditSwitch
            authorizationField={"article.manual_active"}
            value={!!article.manual_active && !!article.active}
            disabled={!article.active && cloudStore.merchant?.merchantable_type != null}
            onChange={(newValue, setBeginValue) => {
              updateArticle(articlesStore.merchantId, article, { manual_active: newValue, active: true }).then(() =>
                setBeginValue(newValue)
              );
            }}
          />
        </div>
        <IconButton
          onClick={() => {
            closeDialog();
            props.onClose();
          }}
          color="primary"
          style={{ position: "absolute", top: "8px", right: "8px" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item container xs={12} md={6} alignContent={"flex-start"} spacing={1} className={classes.padding10}>
            <Grid item className={classes.marginBottom10} xs={6}>
              <EditTextField
                authorizationField={"article.name"}
                label={props.intl.formatMessage({ id: "article_name" })}
                value={getTranslationValue("name", "translation_id", props.currentLanguage, article)}
                placeholder={article.name}
                onBlur={(value, setBeginValue) => {
                  if (props.currentLanguage === cloudStore.merchant.default_language) {
                    updateArticle(articlesStore.merchantId, article, { name: value }).then(() => setBeginValue(value));
                  } else {
                    updateTranslations(value).then(() => setBeginValue(value));
                  }
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={3}>
              <PriceFieldArticle
                article={article}
                setArticle={(article) => {
                  props.setArticle(Object.assign(new Article(), article));
                }}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={3}>
              <EditPriceTextField
                variant={"standard"}
                authorizationField={"article.price"}
                label={props.intl.formatMessage({ id: "action_price" })}
                price={typeof article.meta_json?.originalPrice === "number" ? article.price : ""}
                onBlur={(value, setBeginValue) => {
                  let newOriginalPrice = null;
                  let price = 0;
                  if (value != null && value >= 0) {
                    newOriginalPrice =
                      article.meta_json && typeof article.meta_json.originalPrice === "number"
                        ? article.meta_json.originalPrice
                        : article.price;
                    price = value;
                  } else {
                    price = article.meta_json?.originalPrice;
                  }
                  updateArticle(articlesStore.merchantId, article, {
                    meta_json: { originalPrice: newOriginalPrice },
                    price: price,
                  }).then((article) => {
                    setBeginValue(value);
                    props.setArticle(article);
                  });
                }}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={6}>
              <EditTextField
                authorizationField={"article.print_name"}
                label={props.intl.formatMessage({ id: "batch.print_name" })}
                value={article.print_name === null ? "" : article.print_name}
                onBlur={(value, setBeginValue) => {
                  if (value === "") {
                    value = null;
                  }
                  updateArticle(articlesStore.merchantId, article, { print_name: value }).then(() => {
                    setBeginValue(value == null ? "" : value);
                  });
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={6}>
              <EditTextField
                authorizationField={"article.print_name_2"}
                label={props.intl.formatMessage({ id: "batch.print_name_2" })}
                value={article.print_name_2 === null ? "" : article.print_name_2}
                onBlur={(value, setBeginValue) => {
                  if (value === "") {
                    value = null;
                  }
                  updateArticle(articlesStore.merchantId, article, { print_name_2: value }).then(() => {
                    setBeginValue(value == null ? "" : value);
                  });
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={12}>
              <EditTextField
                multiline
                rowsMax={6}
                authorizationField={"article.description"}
                label={props.intl.formatMessage({ id: "batch.description" })}
                placeholder={article.description}
                value={getTranslationValue("description", "description_translation_id", props.currentLanguage, article)}
                onBlur={(value, setBeginValue) => {
                  if (props.currentLanguage === cloudStore.merchant.default_language) {
                    updateArticle(articlesStore.merchantId, article, { description: value }).then((article) => {
                      setBeginValue(value);
                    });
                  } else {
                    updateTranslationsDescription(value).then(() => setBeginValue(value));
                  }
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <EditSelect
                key={article.type}
                authorizationField={"article.type"}
                value={article.type == null ? "" : article.type}
                optionValues={["ARTICLE", "SERVICE", "FREETPARTICLE"]}
                optionViewValues={["ARTICLE", "SERVICE", "FREETPARTICLE"]}
                onChange={(value, setBeginValue) =>
                  updateArticle(articlesStore.merchantId, article, { type: value }).then(() => setBeginValue(value))
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <EditTextField
                authorizationField={"article.pos_name"}
                label={props.intl.formatMessage({ id: "batch.pos_name" })}
                value={article.pos_name === null ? "" : article.pos_name}
                onBlur={(value, setBeginValue) => {
                  updateArticle(articlesStore.merchantId, article, { pos_name: value }).then(() => {
                    setBeginValue(value == null ? "" : value);
                  });
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={6} sm={4}>
              <EditSelect
                authorizationField={"article.vat_high"}
                value={article.vat_high == null ? "" : article.vat_high.toString()}
                optionValues={Object.keys(articlesStore.vatOptions)
                  .sort()
                  .map((vatOption) => vatOption)}
                optionViewValues={Object.keys(articlesStore.vatOptions)
                  .sort()
                  .map((vatOption) => vatOption * 100 + "%")}
                allowUnknown={true}
                onUnknown={(value, setBeginValue) => {
                  let articlesVat = { ...articlesStore.vatOptions };
                  articlesVat[value / 100.0] = true;
                  setVatOptions(articlesVat);
                  updateArticle(articlesStore.merchantId, article, { vat_high: value / 100.0 }).then(() =>
                    setBeginValue(value)
                  );
                }}
                onChange={(value, setBeginValue) => {
                  if (value !== "+") {
                    updateArticle(articlesStore.merchantId, article, { vat_high: value }).then(() =>
                      setBeginValue(value)
                    );
                  }
                }}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={6} sm={4}>
              <EditNumberField
                authorizationField={"article.weight"}
                label={props.intl.formatMessage({ id: "batch.weight" })}
                value={article.weight === null ? "" : article.weight}
                onBlur={(value, setBeginValue) => {
                  updateArticle(articlesStore.merchantId, article, { weight: value === "" ? null : value }).then(() =>
                    setBeginValue(value == null ? "" : value)
                  );
                }}
                variant={"standard"}
                fullWidth
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={6} sm={4}>
              <EditNumberField
                variant={"standard"}
                authorizationField={"article.max_n"}
                label={"Max N"}
                value={article.max_n === null ? "" : article.max_n}
                onBlur={(value, setBeginValue) => {
                  updateArticle(articlesStore.merchantId, article, { max_n: value === "" ? null : value }).then(() =>
                    setBeginValue(value == null ? "" : value)
                  );
                }}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={12} sm={12}>
              <EditNumberField
                variant={"standard"}
                authorizationField={"article.remark"}
                value={article.meta_json?.remark >= 0 ? article.meta_json.remark : ""}
                label={"max length of " + props.intl.formatMessage({ id: "batch.remark" }) + ", 0 for unlimited"}
                onBlur={(value, setBeginValue) => {
                  if (value < 0) {
                    value = "";
                  }
                  updateArticle(articlesStore.merchantId, article, {
                    meta_json: { remark: value === "" ? false : Number.parseInt(value) },
                  }).then(() => setBeginValue(value >= 0 ? value : ""));
                }}
              />
              <EditTextField
                authorizationField={"article.category"}
                label={props.intl.formatMessage({ id: "article.category" })}
                value={article.category === null ? "" : article.category}
                onBlur={(value, setBeginValue) => {
                  if (value === "") {
                    value = null;
                  }
                  updateArticle(articlesStore.merchantId, article, { category: value }).then(() => {
                    setBeginValue(value == null ? "" : value);
                  });
                }}
                variant={"standard"}
              />
              <EditTextField
                authorizationField={"article.short_key"}
                label={props.intl.formatMessage({ id: "article.short_key" })}
                value={article.short_key === null ? "" : article.short_key}
                onBlur={(value, setBeginValue) => {
                  if (value === "") {
                    value = null;
                  }
                  updateArticle(articlesStore.merchantId, article, { short_key: value }).then(() => {
                    setBeginValue(value == null ? "" : value);
                  });
                }}
                variant={"standard"}
              />
              <EditTextField
                authorizationField={"article.pos_printer_category"}
                label={props.intl.formatMessage({ id: "article.pos_printer_category" })}
                value={article.pos_printer_category === null ? "" : article.pos_printer_category}
                onBlur={(value, setBeginValue) => {
                  if (value === "") {
                    value = null;
                  }
                  updateArticle(articlesStore.merchantId, article, { pos_printer_category: value }).then(() => {
                    setBeginValue(value == null ? "" : value);
                  });
                }}
                variant={"standard"}
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={12} sm={12}>
              <EditTextField
                label={props.intl.formatMessage({ id: "article.min_amount" })}
                value={(article.min_amount / 100.0).toFixed(2)}
                onBlur={(value, setBeginValue) => {
                  updateArticle(articlesStore.merchantId, article, {
                    min_amount: Math.round(parseFloat(value) * 100),
                  }).then(() => {
                    setBeginValue(value);
                  });
                }}
                variant={"standard"}
                InputProps={{
                  startAdornment: <InputAdornment position="start">{GetCurrency()}</InputAdornment>,
                }}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <EditCheckbox
                labelPlacement={"start"}
                color={"primary"}
                authorizationField={"article.handheld_only"}
                value={article.handheld_only}
                label={props.intl.formatMessage({ id: "batch.handheld_only" })}
                onChange={(value) => updateArticle(articlesStore.merchantId, article, { handheld_only: value })}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <EditCheckbox
                labelPlacement={"start"}
                color={"primary"}
                authorizationField={"article.is_menu"}
                value={article.is_menu}
                label={props.intl.formatMessage({ id: "batch.is_menu" })}
                onChange={(value) => updateArticle(articlesStore.merchantId, article, { is_menu: value })}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <EditCheckbox
                labelPlacement={"start"}
                authorizationField={"article.active"}
                value={article.active}
                label={props.intl.formatMessage({ id: "batch.active" })}
                onChange={(value) => updateArticle(articlesStore.merchantId, article, { active: value })}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <EditCheckbox
                labelPlacement={"start"}
                color={"primary"}
                authorizationField={"article.forceAddOnPrintOrderTotalReceipt"}
                value={article.meta_json?.forceAddOnPrintOrderTotalReceipt ?? false}
                label={props.intl.formatMessage({ id: "article.forceAddOnPrintOrderTotalReceipt" })}
                onChange={(value) => {
                  updateArticle(articlesStore.merchantId, article, {
                    meta_json: { forceAddOnPrintOrderTotalReceipt: value },
                  });
                }}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <EditCheckbox
                labelPlacement={"start"}
                color={"primary"}
                authorizationField={"article.view_only"}
                value={!!article.view_only}
                label={props.intl.formatMessage({ id: "article.view_only" })}
                onChange={(value) => {
                  updateArticle(articlesStore.merchantId, article, {
                    view_only: value ? 1 : 0,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <div style={{ margin: 8 }}>
                <Typography>{props.intl.formatMessage({ id: "handheld_background_color" })}</Typography>
                <EditColorPicker
                  authorizationField={"article.handheld_bg_color"}
                  value={article.handheld_bg_color}
                  onChange={(value, setBeginValue) => {
                    updateArticle(articlesStore.merchantId, article, { handheld_bg_color: value }).then(() =>
                      setBeginValue(value)
                    );
                  }}
                />
              </div>
            </Grid>
            <Grid item className={classes.marginBottom10} xs={12} sm={6}>
              <EditImage
                authorizationField={"article.image"}
                value={article.image}
                prefix={"https://mynober-api-public.s3.eu-central-1.amazonaws.com/"}
                onSave={(image, setImagePath) => {
                  uploadArticleImage(articlesStore.merchantId, article.id, image).then((image) => {
                    setImagePath("https://mynober-api-public.s3.eu-central-1.amazonaws.com/" + image);
                  });
                }}
                onRemove={(setImagePath) => {
                  updateArticle(articlesStore.merchantId, article, { image: null }).then(() => {
                    setImagePath(article.image);
                  });
                }}
              />
            </Grid>
            <Grid item xs={11}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography>{props.intl.formatMessage({ id: "order_hours" })}</Typography>
              </div>
              <OpeningHours
                size="small"
                openingHours={article}
                onSave={(newData) => {
                  return new Promise((resolve) => {
                    updateArticle(articlesStore.merchantId, article, newData).then(() => {
                      resolve();
                    });
                  });
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} md={6} className={classes.padding10}>
            <Grid item className={classes.marginBottom10} xs={12} sm={12}>
              <Typography>{props.intl.formatMessage({ id: "batch.allergenIds" })}</Typography>
              <div style={{ width: "auto" }}>
                <EditSelect
                  authorizationField={"article.allergens"}
                  value={article.allergenIds}
                  optionValues={Object.keys(articlesStore.allergens).map((allergenId) => parseInt(allergenId))}
                  optionViewValues={Object.keys(articlesStore.allergens).map((allergenId) => {
                    return articlesStore.allergens[allergenId].name;
                  })}
                  multiple={true}
                  onChange={(value) => updateArticle(articlesStore.merchantId, article, { allergenIds: value }, false)}
                />
              </div>
              {article.allergenIds.length > 0 ? (
                <List classes={{ root: classes.listAllergens }}>
                  {article.allergenIds.map((allergenId) => (
                    <ListItem
                      key={allergenId}
                      style={{
                        margin: "0 1px 1px 1px",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <Tooltip
                        placement={"top"}
                        title={articlesStore.allergens[allergenId].name}
                        style={{ fontSize: "18pt" }}
                      >
                        <img
                          style={{
                            height: "24px",
                            width: "24px",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                          alt={articlesStore.allergens[allergenId].name}
                          src={articlesStore.allergens[allergenId].getImagePath()}
                        />
                      </Tooltip>
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Typography>{props.intl.formatMessage({ id: "no_allergens" })}</Typography>
              )}
            </Grid>
            <Grid item className={classes.marginBottom10} xs={12}>
              <Printgroups
                article={article}
                onChange={(value) =>
                  updateArticle(articlesStore.merchantId, article, { printTags: getTagsString(value) }, false)
                }
              />
            </Grid>
            <Grid item className={classes.section} xs={12}>
              <Supergroups
                article={article}
                onChange={(value) =>
                  updateArticle(articlesStore.merchantId, article, { supergroup_tags: getTagsString(value) }, false)
                }
              />
            </Grid>
            <Grid item className={classes.section} xs={12}>
              <Menugroups
                article={article}
                onChange={(value) =>
                  updateArticle(articlesStore.merchantId, article, { menu_tags: getTagsString(value) }, false)
                }
              />
            </Grid>
            <Grid item className={classes.marginBottom10} xs={12}>
              <Modifiergroups
                article={article}
                onChange={(value, setBeginValue) =>
                  updateArticle(articlesStore.merchantId, article, { modifiergroupIds: value }, false).then(
                    (article) => {
                      setBeginValue(article.modifiergroupIds);
                    }
                  )
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </>
  );
}

export default withIntl(ArticleDetailsDialog);
